import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';

export const baseURI = '/recaudacion/ingresos-de-depositos-en-garantia/';
const files = [
  'archivo_de_identificacion',
  'oficio_de_autorizacion',
  'oficio_de_poder',
];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * GET Depositos en Garantia
 * @returns {Promise<Array<object>>}
 */
export const getDepositosEnGarantia = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Deposito en Garantia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDepositoEnGarantia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Deposito en garantia
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDepositoEnGarantia = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      formData: config.headers,
      files,
      clean: false,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Deposito en garantia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDepositoEnGarantia = async (id, values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      formData: config.headers,
      files,
      clean: false,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues, config);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Deposito en garantia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteDepositoEnGarantia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Generar Cargo de Deposito en Garantia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const postGenerarCargoDeDeposito = async (ingreso_deposito_id) => {
  try {
    await API.post(`${baseURI}generar-cargo/`, { ingreso_deposito_id });
    // onSuccess(response, 'Cargo generado');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Cancelar Deposito en Garantia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object>}
 */
export const postCancelarDepositoEnGarantia = async (id, values) => {
  try {
    const response = await API.post(`${baseURI}${id}/cancelar/`, values);
    return formatReceived(response.data.ingreso_de_deposito_en_garantia);
  } catch (err) {
    onError(err);
    return [];
  }
};
